import { topicItems } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block text-xs font-medium text-primary-600 bg-primary-100/70 px-3 py-1 rounded-full mb-3">
            话题广场
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">热门话题标签</h2>
          <p className="text-sm text-foreground-600 mt-2">当前最受关注的话题方向，点击探索更多精彩内容</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicItems.map((item) => (
            <div
              key={item.name}
              className={`group flex items-center gap-2 px-4 py-2.5 rounded-full border cursor-pointer transition-all ${
                item.hot
                  ? 'bg-primary-500 border-primary-500 text-background-50'
                  : 'bg-background-50 border-background-200 text-foreground-700 hover:border-primary-300 hover:text-primary-500'
              }`}
            >
              {item.hot && <i className="ri-fire-line text-xs"></i>}
              <span className="text-sm font-medium whitespace-nowrap">{item.name}</span>
              <span
                className={`text-xs font-semibold ${
                  item.hot ? 'text-background-50/80' : 'text-foreground-400'
                }`}
              >
                {item.heat}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}